<template>
	<div id="importOrderDialog">
		<el-dialog  title="导入派工"  :visible.sync="isShowDialog" :width="W?'26%':'40%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title" style="width:84px;margin-left:-14px">销售订单号：</span>
                        <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select :remote-method="remoteMethod" @visible-change="closeOrder" @change="orderSelect" clearable style="max-width:180px" filterable remote :loading="loading"  v-model='addForm.orderId' size='small' maxlength='16' placeholder='销售订单号' >
                                <el-option v-for="item in orderList" :key="item.orderId" :value="item.orderId" :label="item.orderCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title">物料编码：</span>
                        <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select @change='materialSelect' :remote-method="query=>{this.remoteMethod1(query)}" remote :loading="loading" remoteMethod1 clearable style="max-width:180px" filterable v-model='addForm.materialId' size='small' maxlength='16' placeholder='物料编码' >
                                <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title">物料名称：</span>
                        <el-form-item   class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select @change='materialSelect' :remote-method="query=>{this.remoteMethod1('',query)}" remote :loading="loading" clearable style="max-width:180px" filterable v-model='addForm.materialId' size='small' maxlength='16' placeholder='物料名称' >
                                <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title">工单号：</span>
                        <el-form-item prop="splitId" class="value" :rules="rules.splitId" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select clearable style="max-width:180px"  filterable v-model='addForm.splitId' size='small' maxlength='16' placeholder='工单号' >
                                <el-option v-for="item in productionBatchCodeList" :key="item.splitId" :value="item.splitId" :label="item.productionBatchCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
            </el-form>

			<div style="text-align: center;">
                <el-button type="primary" @click="submitAddOrder">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>

		</el-dialog>
	</div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils';

export default {
	name: 'AddOrderDialog',
	props: {
        isShow: Boolean,
        technologyId: Number,
        targetSplitId:Number,
        orderCode:String,
	},
	data() {
		return {
            pickerOption:{
                disabledDate(time) {
                    return time.getTime() < Date.now()
                }
            },
            isShowDialog: false,

            addForm:{
                orderId:null,
                materialId:null,
                splitId:'',
                
            },
            rules:{
                splitId: [
                    {required: true, message: '请选择工单', trigger: 'blur'}
                ],
                
            },
            
            W:true,
            loading:false,
            materialList:[],
            orderList:[],
            productionBatchCodeList:[],
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
        
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        submitAddOrder(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.addForm.technologyId = this.technologyId
                    let params = CommonUtils.cloneObj(this.addForm)
                    params.splitId = this.targetSplitId
                    params.targetSplitId = this.addForm.splitId
                    this.$RequestUtil.get({
                        url: '/api/productionTask/executionGroup',
                        type: 'sync',
                        params,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('导入成功!')
                                this.cancelAddDialog()
                                this.$parent.getPlanByTecId(res.data);  
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })
                }
            })
        },

        async loadOrderList(orderCode){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listOrderProduction',type:'async',params: {orderCode}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod(query){
            this.loading = true
            this.orderList = await this.loadOrderList(query)
            this.loading = false
        },

        async closeOrder(ev){
            if(!ev){
                this.orderList = await this.loadOrderList()
            }
        },

        async loadMaterialByOrderId(orderId,materialCode,materialName){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialByOrderCode',type:'async',params: {orderId,materialCode,materialName}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod1(materialCode,materialName){
            this.loading = true
            this.materialList = await this.loadMaterialByOrderId(this.addForm.orderId,materialCode,materialName)
            this.loading = false
        },

        async remoteMethod2(query){
             this.loading = true
            this.materialList = await this.loadProductionBatchCodeByMaterialId(this.addForm.orderId,this.addForm.materialId,query)
            this.loading = false
        },

        async materialSelect(ev){
            
            this.$set(this.addForm,'splitId',null)
            if(!ev){
                this.productionBatchCodeList = []
                return
            }
            this.productionBatchCodeList = await this.loadProductionBatchCodeByMaterialId(this.addForm.orderId,ev)
        },

        async orderSelect(ev){
            this.$set(this.addForm,'materialId',null)
            this.$set(this.addForm,'splitId',null)
            this.productionBatchCodeList = []
            if(!ev){
                this.materialList = []
                return
            }
            this.materialList = await this.loadMaterialByOrderId(ev)
            this.productionBatchCodeList = await this.loadProductionBatchCodeByMaterialId(ev)
        },

        async loadProductionBatchCodeByMaterialId(orderId,materialId,productionBatchCode){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listProductionBatchCode',type:'async',params: {orderId,materialId,productionBatchCode}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

		cancelAddDialog() {
            this.addForm = {
                orderCode:'',
                orderDate:'',
                deliverDate:'',
                customerCode:'',
                customerName:'',
                remark:'',
                itemList:[],
            }
            this.itemList = []
            this.isShowDialog = false
            this.$parent.showImportPlanView = false
        },

	},
	watch: {
		"isShow": async function (newVal, oldVal) {
            if(this.isShow){
                this.orderList = await this.loadOrderList(this.orderCode)
                if(this.orderCode){
                    let orderId = (this.orderList.find(item=>item.orderCode==this.orderCode)||{}).orderId
                    if(orderId){
                        this.$set(this.addForm,'orderId',orderId)
                        await this.orderSelect(orderId)
                    }
                }
            }
			this.isShowDialog = this.isShow;
		},
	},
}
</script>
<style scoped>
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('/static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {
        background-image: url('/static/img/del-hover.png');
        background-repeat: no-repeat;
    }
    .title {
            color: #606266;
            font-family: NotoSansHans-Regula;
            font-size: 14px;
            display: inline-block;
            text-align: right;
            width: 70px;
        }

        .value {
            display: inline-block
        }

    @media screen and (min-width: 1300px) and (max-width: 1930px){
    
    }
</style>


<style>


</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/ImportPlanDialog.vue